var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt5 pb5 flex aic"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"ml10 fontPFM fs18"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }